import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgJotformRegularIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 31 31",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#0A1551",
			d: "M10.3 25.8c.5.4.2 1.2-.5 1.2h-4q-1.4-.2-1.5-1.4v-4c0-.6.8-1 1.2-.5z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFB629",
			d: "M16.7 26.1a3 3 0 0 1 0-4.3l4.3-4.4a3 3 0 0 1 4.4 0 3 3 0 0 1 0 4.3L21 26.1a3 3 0 0 1-4.3 0"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#0099FF",
			d: "M5.2 15.2a3 3 0 0 1 0-4.3l7.3-7.3a3 3 0 0 1 4.4 0 3 3 0 0 1 0 4.4l-7.3 7.2a3 3 0 0 1-4.4 0"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FF6100",
			d: "M11.1 20.4a3 3 0 0 1 0-4.3L21 6.3a3 3 0 0 1 4.4 0 3 3 0 0 1 0 4.3l-9.9 9.8a3 3 0 0 1-4.4 0"
		})
	]
});
export default SvgJotformRegularIcon;
